const shared = {
  home: "Home",
  events: "Events",
  employees: "Employees",
  reports: "Reports",
  finance: "Finance",
  report_not_found: "Reports Not Found",
  requests: "Requests",
  joiningEvents: "Joining Events",
  promotions: "Promotions",
  applicants: "Applicants",
  payroll: "Payroll",
  payrollEvent: "By Events",
  payrollApplicants: "By Applicants",
  timesheet: "Timesheet",
  evaluations: "Evaluations",
  rolesManagement: "Roles Management",
  language: "Ar",
  englishLang: "English (united States)",
  arabicLang: "Arabic (saudi arabia)",
  creatEvent: "Create Event",
  admins: "Admins",
  addAdmin: "Add admins",
  lookups: "Lookups",
  serviceProviderCategories: "Service provider categories",
  serviceProviders: "Service providers",
  specialties: "Specialties",
  services: "Services",
  logout: "Logout",
  lang: "العربية",
  back: "Back",
  search: "Search for an employee",
  searchCountry: "Search country",
  noSearch: "There are no results matching your search",
  noData: "There are no data yet",
  actions: "Actions",
  edit: "Edit",
  add: "Add",
  view: "View",
  delete: "Delete",
  save: "Save",
  submit: "Submit",
  loading: "Loading...",
  cancel: "Cancel",
  close: "Close",
  filter: "Filter",
  confirm: "Confirm",
  approve: "Approve",
  addNote: "Add Note",
  editNote: "Edit Note",
  deleteNote: "Delete Note",
  note: "Note",
  stcNumber: "Stc Number",
  phone_number: "Phone Number",
  editProfile: "Edit Profile",
  dailyAmount: "Daily Amount",
  totalAmount: "Total Amount",
  numberOfWorkingDays: "Number of Working Days",
  block: "Block",
  blocked: "Blocked",
  unBlock: "Unblock",
  none: "None",
  id: "ID",
  viewMore: "View More",
  addYourNote: "Add Your Note",
  clientSurvey: "Client Survey",
  heatMap: "Heatmap",
  clients: "Clients",
  companies: "Companies",
  registrationRequestsMenu: "Registration Req.",
  demoRequestsMenu: "Demo Req.",
  profileEditRequestsMenu: "Profile Edit Req.",
  companiesListMenu: "Companies",
  clientsManagement: "Clients Management",
  surveryScore: "Survey Score",
  scoreNotFound: "Score not found",
  manageReports: "Manage Reports",
  lists: {
    enTitle: "Title (En)",
    arTitle: "Title (Ar)",
    enName: "Name (En)",
    arName: "Name (Ar)",
    name: "Name",
    email: "Email",
    phone: "Phone number",
    image: "Image",
    categories: "Categories",
    status: "Status",
  },
  noHavePermission: "You don't have any permissions yet!",
  filesAccepted: "Max size: 5MB, accepted formats: jpg, jpeg, png, and bmp",
  uploadTypeError: "Accepted formats are jpg, jpeg, png, and bmp only",
  uploadSizeError: "Max size is 5MB",
  uiUploadInvalidType: "Accepted formats: JPG, PNG, SVG",
  uiUploadMaxSize: "Max file size is {size}",
  acceptedFormatLabel: "Accepted format",
  noOptions: "No options",
  pdfUploadTypeError: "Accepted format is PDF only",
  pdfUploadSizeError: "Max size is 5MB",
  dynamicTableActions: {
    columnMenuShowColumns: "Show columns",
    columnsPanelTextFieldLabel: "Find column",
    columnsPanelTextFieldPlaceholder: "Column title",
    columnsPanelShowAllButton: "Show all",
    columnsPanelHideAllButton: "Hide all",
    columnMenuLabel: "Menu",
  },
  role: "Role",
  gender: "Gender",
  male: "Male",
  female: "Female",
  notProvided: "Not Provided",
  noInternetConnection: "No Internet Connection",
  generalErrMsg: "Sorry, something went wrong!",
  cm: "Cm",
  kg: "Kg",
  genderOptions: {
    male: "Male",
    female: "Female",
    prefer_not_to_say: "Not Provided",
  },
  status: "Status",
  image: "Image",
  eventStatusOptions: {
    ongoing: "Ongoing",
    upcoming: "Upcoming",
    past: "Completed",
    pending: "Pending",
    canceled: "Cancelled",
  },
  hint: "To change the role before approving the request, edit the dropdown selection",
  sar: "SAR",
  other: "Other",
  location: "Location",
  meter: "meters",
  minutes: "minutes",
  workingDurationHour: "H",
  workingDurationMinute: "Min",
  select: "Select",
  numberOfRows: "Number Of Rows",
  dateInputFormatPlaceholder: "dd/mm/yyyy",
  invite: "Invite",
  selected: "Selected",
  outOf: "Out Of",
  all: "All",
  locationError: "Enter location name less then 20 characters",
  locationPlaceholderOther: "Enter other option",
  selectedLocation: "--Select Location--",
  selectedReason: "--Select Reason--",
  sureMessage: "Are you sure you want to delete this location?",
  listBreadCrumbs: {
    listJoiningBreadcrumb: "Joining Events",
    listPayrollBreadcrumb: "Payroll Events",
    listReportsBreadcrumb: "Reports Events",
    heatMap: "Heat Maps",
    reports: "Reports",
    surveyScore: "Survey Scores",
  },
  promoteToAdmin: "Promote To Admin",
  demoteToAdmin: "Demote To Admin",
  adminPrivileges: "Admin Privileges",
  accessRights:
    "Sorry you don't have no access rights. Please contact to the admin super_admin@example.com",
  report_desp:
    "Select One of the events below to view the documents inside each query.",
  downloadAll: "Download All",
  download: "Download",
  expandImageFullSize: "View image full size",
  closeImageViewer: "Close viewer",
  uploadFile: "Upload File",
  uploadedSuccessfully: "Uploaded Successfully",
  removeFile: "Remove file",
  addShift: "Add Shift",
  date: "Date",
  selectDate: "Select Date",
  am: "AM",
  pm: "PM",
  shiftTypes: {
    morning_shift: "Morning Shift",
    evening_shift: "Evening Shift",
    night_shift: "Night Shift",
    full_time: "Full Time",
    morning: "Morning",
    evening: "Evening",
    night: "Night",
    fullTime: "Full Time",
    Morning: "Morning",
    Evening: "Evening",
    Night: "Night",
    Full_Time: "Full Time",
  },
  joined: "Joined",
  dashboard: "Dashboard",
  settings: "Settings",
  companyPortalProfile: "Profile",
  companyPortalTeamPermissions: "Team & Permissions",
  companyPortalLoyalApplicants: "Loyal Applicants",
  companyPortalRolesManage: "Roles Manage",
  companyPortalSecurity: "Security",
  security: "Security",
  companyPortalCountry: "Country",
  companyPortalAccountStatus: "Account status",
  companyPortalLanguage: "Language",
  companyPortalProfileVerified: "Verified",
  companyPortalProfileUnverified: "Not verified",
  editRequestBanner: {
    approved: "Your edit request has been approved successfully",
    declined: "Your edit request has been declined",
    pending: "Your edit request has been submitted and is pending review",
    reviewing:
      "Your edit request is currently being reviewed. You will be notified once it is approved.",
    actions: {
      dismiss: "Dismiss",
      viewDetails: "View Details",
      cancelRequest: "Cancel Request",
      editRequest: "Edit Request",
    },
    editProfileLocked:
      "You can't edit your profile while a request is being reviewed or has been processed.",
    cancelConfirmDialog: {
      title: "Cancel Request",
      message:
        "Are you sure do you want to cancel your Request",
      no: "No",
      yes: "Yes",
    },
  },
};

export default shared;
